import { IonButton, IonContent } from '@ionic/react';
import GolfIcon from '../GolfIcon';
import { useTranslation } from 'react-i18next';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

type GameErrorProps = {
  status?: number;
  message: string;
  onBack?: () => void;
};

const GameError: React.FC<GameErrorProps> = ({ status, message, onBack }) => {
  const { t } = useTranslation();

  return (
    <IonContent scrollY={false} className="ion-padding">
      <div className="flex flex-col items-center justify-center min-h-full text-center">
        <div className="mb-6">
          <DotLottieReact className="w-full" src="/assets/lottie/notfound.json" autoplay loop />
        </div>
        <h1 className="text-2xl font-bold mb-2">
          {status === 404
            ? t('game_not_found_title')
            : status === 403
              ? t('access_denied_title')
              : t('error_title')
          }
        </h1>
        <p className="text-gray-500 mb-8">{message}</p>
        <IonButton
          expand="block"
          onClick={onBack}
          className="w-full max-w-xs"
        >
          {t('back')}
        </IonButton>
      </div>
    </IonContent>
  );
};

export default GameError;
